var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministratorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.944,
    height: 87.292,
    viewBox: "0 0 110.944 87.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(-5296.123 -3779.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M52.44,56.486H11.126a1.1,1.1,0,0,1-1.1-1.1V8.3a8.311,8.311,0,0,1,8.3-8.3H83.97a8.311,8.311,0,0,1,8.3,8.3v6.8a1.1,1.1,0,0,1-2.2,0V8.3a6.105,6.105,0,0,0-6.1-6.1H18.327a6.106,6.106,0,0,0-6.1,6.1V54.283H52.44a1.1,1.1,0,1,1,0,2.2",
    transform: "translate(5294.059 3780.362)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M43.4,83.546H8.462A8.5,8.5,0,0,1,0,75.035a1.1,1.1,0,0,1,2.2,0,6.291,6.291,0,0,0,6.259,6.308H43.4a1.1,1.1,0,0,1,0,2.2",
    transform: "translate(5296.723 3760.713)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M67.037,11.419h-4.4a1.1,1.1,0,1,1,0-2.2h4.4a1.1,1.1,0,1,1,0,2.2",
    transform: "translate(5280.368 3777.912)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M100.3,62.927c-10.185,0-18.471-8.519-18.471-18.991S90.12,24.945,100.3,24.945s18.47,8.519,18.47,18.991-8.285,18.991-18.47,18.991m0-35.412A16.186,16.186,0,0,0,84.4,43.936a15.909,15.909,0,1,0,31.8,0,16.185,16.185,0,0,0-15.9-16.421",
    transform: "translate(5274.975 3773.732)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M105.631,105.793H65.723a1.285,1.285,0,0,1-1.285-1.285V97.026A26.291,26.291,0,0,1,77.552,74.308a1.285,1.285,0,0,1,1.284,2.225A23.714,23.714,0,0,0,67.008,97.026v6.2h38.623a1.285,1.285,0,0,1,0,2.57",
    transform: "translate(5279.598 3760.659)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M142.738,105.794h-7.483a1.285,1.285,0,1,1,0-2.57h6.2v-6.2a23.713,23.713,0,0,0-11.829-20.492,1.285,1.285,0,0,1,1.284-2.225,26.288,26.288,0,0,1,13.114,22.718v7.482a1.285,1.285,0,0,1-1.285,1.285",
    transform: "translate(5262.444 3760.659)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorIcon);
export default __webpack_public_path__ + "static/media/administrator-icon.f26fb21d50bcd628a59d12e05b438e6a.svg";
export { ForwardRef as ReactComponent };